/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import { onAuthState } from 'app/actions/authActions';
import { Auth } from 'aws-amplify';
import { t } from 'i18next';
import { useRef } from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { ArrowDownIcon, LogoutIcon, CreditCardIcon } from '../Icons';
import useOutsideClick from 'shared/hooks/useOutsideClick';
import AvatarImg from '../AvatarImg';
import { useCredits } from 'hooks/useCredits';
import { getLocalizedPath } from 'utils/languageHelpers';

const MobileDropMenu = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const account = useSelector(state => state.account);
  const { balance, subscriptionTier } = useCredits();
  const [open, setOpen] = useState(false);
  const dropdown = useRef();
  const toggleButton = useRef();

  const toggleDropdown = () => setOpen(!open);
  useOutsideClick([dropdown, toggleButton], () => setOpen(false));

  const getTierColor = tier => {
    switch (tier) {
      case 'FREE':
        return '#0C0C0B';
      case 'STARTER':
      case 'PRO':
      case 'PREMIUM':
        return '#FF411A';
      default:
        return '#0C0C0B';
    }
  };

  return (
    <div className={`mobile-drop-menu d-flex align-items-center ${open ? 'active' : ''}`}>
      <div
        className='profile-avatar mr-0 mr-md-5 rounded-10'
        onClick={() => history.push(getLocalizedPath('/profile'))}
      >
        <AvatarImg size='sm' width='32px' height='32px' picture={account.picture} name={account.name} />
      </div>
      <div ref={toggleButton} className='drop-toggle cursor-pointer' onClick={toggleDropdown} role='presentation'>
        <ArrowDownIcon className='ml-md-5 ml-0 drop-icon' />
      </div>
      <div className='drop-content' ref={dropdown}>
        <div className='d-flex flex-column align-items-center border-bottom'>
          <AvatarImg
            width='88px'
            height='88px'
            size='lg'
            className='mb-3'
            picture={account.picture}
            name={account.name}
          />
          <h1 className='mb-2'>{account.name}</h1>

          {/* Mobile Credit Balance */}
          <div
            className='mobile-credit-balance d-flex align-items-center mb-3 cursor-pointer'
            onClick={() => {
              setOpen(false);
              history.push(getLocalizedPath('/profile/credits'));
            }}
            style={{
              background: '#f8fafc',
              border: '1px solid #f1f5f9',
              borderRadius: '8px',
              padding: '8px 12px',
              transition: 'all 0.2s ease',
            }}
          >
            <CreditCardIcon
              style={{
                width: '16px',
                height: '16px',
                marginRight: '6px',
                color: '#64748b',
              }}
            />
            <div className='d-flex flex-column align-items-center'>
              <span
                style={{
                  fontSize: '14px',
                  fontWeight: '600',
                  color: '#0C0C0B',
                  lineHeight: '1',
                }}
              >
                {balance}
              </span>
              <span
                style={{
                  fontSize: '10px',
                  color: getTierColor(subscriptionTier),
                  fontWeight: '600',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em',
                  lineHeight: '1',
                }}
              >
                {subscriptionTier}
              </span>
            </div>
          </div>
        </div>
        <div className='d-flex align-items-center justify-content-around pt-7'>
          <div
            className='d-flex align-items-center'
            onClick={() => {
              dispatch(onAuthState(0));
              Auth.signOut();
            }}
          >
            <LogoutIcon className='mr-3' />
            {t('text_logout')}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileDropMenu;
